import Cookies from 'js-cookie'

const TokenKey = 'ahxmgk-manage-acc-dian-' + process.env.VUE_APP_Q


export function getAcc() {
  let acc = Cookies.get(TokenKey)
  if(acc)return JSON.parse(acc)
  return {}
}

export function setAcc(token) {
  return Cookies.set(TokenKey, JSON.stringify(token))
}

export function removeAcc() {
  return Cookies.remove(TokenKey)
}